import { FRAME_RATE } from "./constants.js";

const TIME_TOKEN_RE = /\{time\}/g;

export class SimulationClock {
  constructor() {
    this.frames = 0;
    this.freezeFrames = 0;
    this.paused = true;
    this.textTemplate = "Time: {time}";
  }

  update() {
    if (!this.paused) {
      this.frames += 1;
    }
    if (this.freezeFrames > 0) {
      this.freezeFrames -= 1;
    }
  }

  Pause() {
    this.paused = true;
  }

  unpause() {
    this.paused = false;
  }

  Freeze(frames = -1) {
    this.freezeFrames = frames;
  }

  unfreeze() {
    this.freezeFrames = 0;
  }

  reset() {
    this.frames = 0;
    this.freezeFrames = 0;
    this.paused = true;
  }

  getState() {
    return {
      frames: this.frames,
      freezeFrames: this.freezeFrames,
      paused: this.paused,
      textTemplate: this.textTemplate,
    };
  }

  setState(state) {
    this.frames = state.frames ?? 0;
    this.freezeFrames = state.freezeFrames ?? 0;
    this.paused = state.paused ?? true;
    this.textTemplate = state.textTemplate ?? "Time: {time}";
  }

  formatTime(frameCount) {
    const safeFrameCount = Math.max(0, Math.floor(frameCount));
    const seconds = Math.floor(safeFrameCount / FRAME_RATE);
    const subFrame = safeFrameCount % FRAME_RATE;
    return `${seconds}:${subFrame}`;
  }

  get textContent() {
    return this.textTemplate.replace(TIME_TOKEN_RE, this.formatTime(this.frames));
  }
}
